function formatDateDDMMMYYYY(dateObj) {
    // 1) Extract day, month, year
    const day = String(dateObj.getDate()).padStart(2, "0");
    const year = dateObj.getFullYear();

    // 2) Array of abbreviated month names
    const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    const month = monthNames[dateObj.getMonth()];

    // 3) Construct your desired format
    return `${day} - ${month} - ${year}`;
}
function timeAgo(dateString) {
    const date = new Date(dateString);
    const now = new Date();
    const diff = now - date;

    if (isNaN(date.getTime())) return dateString;

    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (seconds < 60) return "Just now";
    if (minutes < 60)
        return minutes + (minutes === 1 ? " minute ago" : " minutes ago");
    if (hours < 24) return hours + (hours === 1 ? " hour ago" : " hours ago");
    if (days < 7) return days + (days === 1 ? " day ago" : " days ago");
    if (weeks < 5) return weeks + (weeks === 1 ? " week ago" : " weeks ago");
    if (months < 12)
        return months + (months === 1 ? " month ago" : " months ago");
    return years + (years === 1 ? " year ago" : " years ago");
}

/* Apply the transformation on DOM load */
function applyTimeAgoFormatting(container = document) {
    container.querySelectorAll("[data-time-ago]").forEach((el) => {
        const rawDate = el.getAttribute("data-time-ago");
        const dateObj = new Date(rawDate);
        el.textContent = timeAgo(rawDate);
        el.title = isNaN(dateObj.getTime()) ? rawDate : formatDateDDMMMYYYY(dateObj);
    });
}

// Initial run on page load
document.addEventListener("DOMContentLoaded", () => {
    applyTimeAgoFormatting();
});
